// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c-search-filter{display:flex;flex-shrink:0;align-items:center;margin:0 16px 16px 16px;background-color:var(--background--highlight)}.c-search-filter__search{background-color:var(--background--secondary)}.c-search-filter__button{margin-left:8px}", ""]);
// Exports
module.exports = exports;
